import { Helmet } from "react-helmet-async";

const cardData = [
  {
    title: "Crown and Bridge",
    description: "Giving your teeth a royal upgrade",
    items: [
      {
        label: "Single Posterior Crown",
        image: "/Services/single_posterior_crown.png",
      },
      {
        label: "Single Anterior Crown",
        image: "/Services/single_anterior_crown.png",
      },
      {
        label: "Anterior Bridge",
        image: "/Services/anterior_bridge_transparent.png",
      },
      {
        label: "Anterior Crown",
        image: "/Services/anterior_crown_transparent.png",
      },
      {
        label: "Coping",
        image: "/Services/coping_transparent.png",
      },
      {
        label: "Facial Cutback",
        image: "/Services/facial_cutback_transparent.png",
      },
      {
        label: "Posterior Bridge",
        image: "/Services/posterior_bridge_transparent.png",
      },
      {
        label: "Posterior Crown",
        image: "/Services/posterior_crown_transparent.png",
      },
      {
        label: "Veeners",
        image: "/Services/veneers.png",
      },
    ],
  },
  {
    title: "Smile Design",
    description: "Crafting smiles that speak louder than words",
    items: [
      {
        label: "Full Arch Rehabilitation",
        image: "/Services/full_arch_rehab.png",
      },
      {
        label: "Restorative Wax-up",
        image: "/Services/restorative_wax_up.png",
      },
      {
        label: "Additive Wax-up",
        image: "/Services/additive_wax_up.png",
      },
      {
        label: "No-prep Veneers",
        image: "/Services/no_prep_veneers.png",
      },
      {
        label: "Immediate Temporaries",
        image: "/Services/immediate_temporaries.png",
      },
      {
        label: "Shell Crowns",
        image: "/Services/shell_crowns.png",
      },
    ],
  },
  {
    title: "Removables",
    description: "Turning missing teeth into masterpieces",
    items: [
      {
        label: "Removable Partial Dentures",
        image: "/Services/removable_partial_dentures.png",
      },
      {
        label: "Copy Dentures",
        image: "/Services/copy_dentures.png",
      },
      {
        label: "Complete Dentures",
        image: "/Services/complete_dentures.png",
      },
      {
        label: "Metal Framework",
        image: "/Services/metal_framework.png",
      },
      {
        label: "Split-files for Dentures",
        image: "/Services/split_files_for_dentures.png",
      },
    ],
  },
  {
    title: "Implants",
    description: "Dental implants that stand the test of time",
    items: [
      {
        label: "Custom Abutment",
        image: "/Services/custom_abutment.png",
      },
      {
        label: "Implant Crowns",
        image: "/Services/implant_crown.png",
      },
      {
        label: "Screw-retained Bridges",
        image: "/Services/screw_retained_bridge.png",
      },
      {
        label: "Implant Bar",
        image: "/Services/implant_bar.png",
      },
      {
        label: "Bar-supported Prosthesis",
        image: "/Services/bar_supported_prosthesis.png",
      },
      {
        label: "All-on-X",
        image: "/Services/all_on_x.png",
      },
      {
        label: "Surgical Guide",
        image: "/Services/surgical_guide.png",
      },
    ],
  },
  {
    title: "Miscellaneous",
    description: "",
    items: [
      {
        label: "Post and Core",
        image: "/Services/post_and_core.png",
      },
      {
        label: "Night Guard",
        image: "/Services/night_guard.png",
      },
      {
        label: "Device for Sleep Apnea",
        image: "/Services/device_for_sleep_apnea.png",
      },
      {
        label: "Digital Model",
        image: "/Services/digital_model.png",
      },
      {
        label: "Model for Bleaching Tray",
        image: "/Services/model_for_tray_bleaching.png",
      },
      {
        label: "Custom Tray",
        image: "/Services/custom_tray.png",
      },
      {
        label: "Ortho Study Model",
        image: "/Services/ortho_study_models.png",
      },
      {
        label: "Implant Model",
        image: "/Services/implant_models.png",
      },
    ],
  },
];

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
const Services = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);

      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [hash]);

  return (
    <>
      <Helmet>
        <title>Services</title>
      </Helmet>
      <div
        id="here"
        className="w-full h-full bg-black text-white py-12 md:py-[4vw]"
      >
        <div className="px-8 md:px-[5vw]">
          <h1 className="text-4xl text-center md:text-left md:text-[4vw] font-bold mb-8 md:mb-12">
            Services
          </h1>
        </div>

        {cardData.map((data, index) => (
          <div
            className={`px-8 md:pl-[5vw] md:pr-[2vw] py-10 md:py-[1vw] flex flex-col md:flex-row w-full h-full md:h-[18vw] ${
              index % 2 == 0 ? "bg-[#424242]" : "bg-[#545454]"
            } `}
            key={index}
          >
            <div className="md:min-w-[25vw] py-[3vw] h-full">
              <h2 className="text-2xl md:text-[1.6vw] font-bold mb-2">
                {data.title}
              </h2>
              <p className="mb-6 text-lg md:text-[1vw]">{data.description}</p>
            </div>

            <div className="overflow-x-auto w-full h-40 md:h-full">
              <div className="flex space-x-10 w-full">
                {data.items.map((item, index) => (
                  <div
                    key={index}
                    className="text-center min-w-40 h-24 md:min-w-[14vw] md:h-[10vw] hover:scale-105 transition-all duration-300 cursor-pointer"
                  >
                    <img
                      src={item.image}
                      alt={item.label}
                      className="w-full h-full object-contain"
                    />
                    <p className="mt-2 text-base md:text-[1vw]">{item.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Services;
